var _ellipse, _ellipse2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16.5892,
    rx: 16,
    ry: 16.3795,
    fill: "#FF6433",
    fillOpacity: 0.46
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16.5,
    rx: 9,
    ry: 9.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.60797C10.6239 6.60797 6.25 11.0856 6.25 16.5892C6.25 22.0929 10.6239 26.5705 16 26.5705C21.3761 26.5705 25.75 22.0929 25.75 16.5892C25.75 11.0856 21.3761 6.60797 16 6.60797ZM13.6459 12.2138C14.2398 11.5693 15.0756 11.2147 16 11.2147C16.9244 11.2147 17.7527 11.5717 18.3489 12.2196C18.9531 12.876 19.247 13.758 19.1777 14.7062C19.0389 16.5892 17.6139 18.1248 16 18.1248C14.3861 18.1248 12.9583 16.5892 12.8223 14.7058C12.7534 13.7499 13.0469 12.865 13.6459 12.2138ZM16 25.0349C14.8987 25.0357 13.8084 24.81 12.7938 24.3713C11.7793 23.9326 10.8611 23.2898 10.0938 22.4811C10.5332 21.8395 11.0932 21.294 11.7409 20.8764C12.9358 20.0923 14.448 19.6604 16 19.6604C17.552 19.6604 19.0642 20.0923 20.2577 20.8764C20.9059 21.2938 21.4664 21.8393 21.9062 22.4811C21.139 23.2899 20.2208 23.9328 19.2062 24.3715C18.1917 24.8102 17.1014 25.0358 16 25.0349Z",
    fill: "#FF460A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.381c6e470b56a00f6f1f8deb31ca7d2e.svg";
export { ForwardRef as ReactComponent };